// The single wrapper every API call goes through. Fails CLOSED: it never sends
// an unauthenticated request and lets the backend 401 it.
import {
  getMsalInstance,
  getAuthConfig,
  getAccessToken,
  loginRedirect,
} from './index';

export async function authFetch(input, init = {}, resourceName = 'api') {
  const config = getAuthConfig();
  const instance = getMsalInstance();
  if (!config) throw new Error('authFetch: auth config missing — bootstrap did not run.');
  if (!instance) throw new Error('authFetch: MSAL instance missing — initAuth was not called.');

  const account = instance.getActiveAccount() || instance.getAllAccounts()[0];
  const token = await getAccessToken(resourceName);

  if (!token) {
    // An account exists but no token came back → force interactive login and
    // throw. Never send an unauthenticated request.
    if (account) {
      try {
        await loginRedirect(resourceName);
      } catch (_) {
        /* redirect may already be in progress */
      }
    }
    throw new Error(
      'authFetch: no access token available; refusing to send an unauthenticated request.'
    );
  }

  const headers = new Headers(init.headers || {});
  headers.set('Authorization', `Bearer ${token}`);
  // Let the browser set the multipart boundary for FormData bodies.
  if (!(init.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  return fetch(input, { ...init, headers });
}
